// src/services/sectionService.js
import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';


export const sectionService = {

  getAll: async (filters = {}) => {
    try {
      const response = await apiClient.get(ENDPOINTS.SECTIONS.GET_ALL, { params: filters });
      return response;
    } catch (error) {
      console.error('Failed to fetch sections:', error);
      throw error;
    }
  },


  create: async (sectionData) => {
    try {
      const response = await apiClient.post(ENDPOINTS.SECTIONS.CREATE, sectionData);
      return response;
    } catch (error) {
      console.error('Failed to create section:', error);
      throw error;
    }
  },


  update: async (id, sectionData) => {
    try {
      const response = await apiClient.put(ENDPOINTS.SECTIONS.UPDATE(id), sectionData);
      return response;
    } catch (error) {
      console.error(`Failed to update section ${id}:`, error);
      throw error;
    }
  },


  delete: async (id) => {
    try {
      const response = await apiClient.delete(ENDPOINTS.SECTIONS.DELETE(id));
      return response;
    } catch (error) {
      console.error(`Failed to delete section ${id}:`, error);
      throw error;
    }
  },


  activate: async (id) => {
    try {
      const response = await apiClient.put(ENDPOINTS.SECTIONS.ACTIVATE(id));
      return response;
    } catch (error) {
      console.error(`Failed to activate section ${id}:`, error);
      throw error;
    }
  },


  deactivate: async (id) => {
    try {
      const response = await apiClient.put(ENDPOINTS.SECTIONS.DEACTIVATE(id));
      return response;
    } catch (error) {
      console.error(`Failed to deactivate section ${id}:`, error);
      throw error;
    }
  },
};

export default sectionService;
